// extracted by mini-css-extract-plugin
export var addButton = "_5q-d";
export var bullets = "_5q-e";
export var compact = "_5q-2";
export var container = "_5q-j";
export var extendedWarrantyModal = "_5q-f";
export var learn = "_5q-l";
export var learnMore = "_5q-g";
export var offeringOption = "_5q-3";
export var offeringPrice = "_5q-8";
export var offeringSubtitle = "_5q-7";
export var offeringTitle = "_5q-6";
export var offeringsContainer = "_5q-0";
export var pdpTilesBackground = "_5q-n";
export var plan = "_5q-m";
export var regular = "_5q-1";
export var remove = "_5q-k";
export var seeDetailsIcon = "_5q-i";
export var seeDetailsLink = "_5q-h";
export var selectedOption = "_5q-4";
export var shieldIcon = "_5q-b";
export var shieldIconCompact = "_5q-c";
export var subtitle = "_5q-a";
export var title = "_5q-9";
export var unselectedOption = "_5q-5";